module.exports = __webpack_public_path__ + "media/images/slider-arrow-l@2x-2815873cc7d9a237893b787201296c37.png";